import React, { forwardRef }  from 'react';

import CarouselRow from 'bdvp-common/src/containers/CarouselRow';
import GamesRow from 'bdvp-common/src/containers/GamesRow';
import CategoryRowV1 from 'bdvp-common/src/containers/CategoryRowV1';
import { CategoryRowV2 } from 'bdvp-common/src/components/CategoryRow';
import PersonalizedRowV1 from 'bdvp-common/src/containers/PersonalizedRowV1';
import PersonalizedRowV2 from 'bdvp-common/src/containers/PersonalizedRowV2';
import StoriesRow from 'bdvp-common/src/containers/StoriesRow';
import SuggestionsRow from 'bdvp-common/src/containers/SuggestionsRow';
import { CarouselRowType } from 'bdvp-common/src/utils/constants';

export const SectionType = {
    CAROUSEL: 'CAROUSEL',
    FEATURED_CAROUSEL: 'FEATURED_CAROUSEL',
    SUGGESTIONS_CAROUSEL: 'SUGGESTIONS_CAROUSEL',
    GAMES: 'GAMES',
    CATEGORY_V1: 'CATEGORY_V1',
    CATEGORY_V2: 'CATEGORY_V2',
    PERSONALIZED_V1: 'PERSONALIZED_V1',
    PERSONALIZED_V2: 'PERSONALIZED_V2',
    STORIES: 'STORIES',
};
// ----------------------------------------------------------------------


const Section = forwardRef(({
    type,
    ...props
}, ref) => {

    switch(type) {

        case SectionType.CAROUSEL:
            return <CarouselRow ref={ref} {...props} />;
        case SectionType.FEATURED_CAROUSEL:
            return <CarouselRow ref={ref} {...props} type={CarouselRowType.FEATURED} />;
        case SectionType.SUGGESTIONS_CAROUSEL:
            return <SuggestionsRow ref={ref} {...props} />;
        case SectionType.GAMES:
            return <GamesRow ref={ref} {...props} />;
        case SectionType.CATEGORY_V1:
            return <CategoryRowV1 ref={ref} {...props} />;
        case SectionType.CATEGORY_V2:
            return <CategoryRowV2 ref={ref} {...props} />;
        case SectionType.PERSONALIZED_V1:
            return <PersonalizedRowV1 ref={ref} {...props} />;
        case SectionType.PERSONALIZED_V2:
            return <PersonalizedRowV2 ref={ref} {...props} />;
        case SectionType.STORIES:
            return <StoriesRow ref={ref} {...props} />;
        default:
            return null;

    }

});

export default Section;
